<script setup lang="ts">
import { ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import Select from '@/components/ui/Select.vue';
import { useThreadStore } from '@/stores/thread';
import type { SelectValue } from '@/types/thread';

const { t } = useI18n();
const threadStore = useThreadStore();
const { selectedMode, loading } = toRefs(threadStore);

const modeList = ref<SelectValue[]>([{ label: t('home.modes.company'), value: 'company' }, { label: t('home.modes.personal'), value: 'personal' }]);

watch(() => selectedMode.value, async () => {
  if (loading.value) return;
  threadStore.clearState();
  await threadStore.getThreadList();
});
</script>

<template>
  <Select
    v-model="selectedMode"
    :options="modeList"
    input-id="mode-switcher"
    width="200px"
    :clearable="false"
    hide-search
    class="search"
  />
</template>

<style scoped lang="scss">
.search {
  margin-right: 16px;
}
</style>
